import { Category } from "./Types";

function createCategory(
    name: string,
    category_id: number | number[],
    alias?: string
): Category {
    return {
        name,
        alias: alias || name,
        category_id: Array.isArray(category_id) ? category_id : [category_id],
    };
}

const Categories = {
    Closing: createCategory("Closing", 1),
    ClosingON: createCategory("Closing", 1, "Closing Letters and Documents"),
    Initial: createCategory("Initial", 2, "Initial Letters and Documents"),
    PostClosing: createCategory("Post-Closing", 3, "Post-Closing Letters and Documents"),
    Mortgage: createCategory("Mortgage", 4, "Mortgage Letters and Documents"),
    ClearanceSearch: createCategory("Clearance Search", 5, "Clearance Search Letters and Forms"),
    SearchLettersRequests: createCategory("Search Letters / Requests", 5),
    PolarisEnglish: createCategory("Polaris (English)", 8, "Polaris Documents (English)"),
    Ereg: createCategory("E-reg", 9, "E-reg Documents"),
    Registration: createCategory("Registration", 9, "Registration Letters and Documents"),
    LandRegistration: createCategory("Land Registration", 9, "Land Registration Documents"),
    Hidden: createCategory("[ Hidden ]", 12, "[ Hidden Documents ]"),
    EnvelopeFax: createCategory("Envelopes and Fax Cover Sheets", 13),
    MunicipalityClosing: createCategory("Jurisdiction Specific Closing", 14, "Jurisdiction Specific Closing Letters and Documents"),
    PolarisFrench: createCategory("Polaris (French/Bilingual)", 15, "Polaris Documents (French/Bilingual)"),
    LegacyCommercial: createCategory("Legacy Commercial", 16, "Legacy Commercial Documents"),
    WesternProtocol: createCategory("Western Protocol", 17),
    ONStandardClosing: createCategory("Ontario Standard Closing", 17, "Ontario Standard Closing Documents"),
    BankForms: createCategory("Bank Forms and Lender Specific", [18, 19, 20], "Bank Forms and Lender Specific Documents"),
    Rental: createCategory("Rental", 18, "Rental Documents"),
    Subdocs: createCategory("Subdocs", 19, "Sub Documents (not for individual production)"),
    LDDLegacy: createCategory("LDD Legacy", 22, "LDD Legacy Documents"),
    Commercial: createCategory("Commercial", 23, "Commercial Documents"),
    CorporateCommercial: createCategory("Corporate - Commercial", 24),
    PrivateLender: createCategory("Private Lender", 25),
    CorporatePrivateLender: createCategory("Corporate - Private Lender", 26),
};

// set parent and children
Categories.ClosingON.children = [Categories.ONStandardClosing];
Categories.MunicipalityClosing.children = [Categories.ONStandardClosing];
Categories.ONStandardClosing.parentNames = [Categories.ClosingON.name, Categories.MunicipalityClosing.name];

Categories.Commercial.children = [Categories.CorporateCommercial];
Categories.CorporateCommercial.parentNames = [Categories.Commercial.name];

Categories.PrivateLender.children = [Categories.CorporatePrivateLender];
Categories.CorporatePrivateLender.parentNames = [Categories.PrivateLender.name];


// province specific category lists
export const CategoryMap: Record<string, Record<number, Category[]>> = {
    ON: {
        1: [Categories.ClosingON],
        2: [Categories.Initial],
        3: [Categories.PostClosing],
        4: [Categories.Mortgage],
        5: [Categories.ClearanceSearch],
        8: [Categories.PolarisEnglish],
        9: [Categories.Ereg],
        12: [Categories.Hidden],
        13: [Categories.EnvelopeFax],
        14: [Categories.MunicipalityClosing],
        15: [Categories.PolarisFrench],
        16: [Categories.LegacyCommercial],
        17: [Categories.ONStandardClosing],
        20: [Categories.BankForms],
        22: [Categories.LDDLegacy],
        23: [Categories.Commercial],
        24: [Categories.CorporateCommercial],
        25: [Categories.PrivateLender],
        26: [Categories.CorporatePrivateLender],
    },
    AB: {
        1: [Categories.Closing],
        2: [Categories.Initial],
        3: [Categories.PostClosing],
        4: [Categories.Mortgage],
        5: [Categories.ClearanceSearch],
        12: [Categories.Hidden],
        13: [Categories.EnvelopeFax],
        14: [Categories.Registration],
        17: [Categories.WesternProtocol],
        19: [Categories.Subdocs],
        20: [Categories.BankForms],
    },
    BC: {
        1: [Categories.Closing],
        2: [Categories.Initial],
        3: [Categories.PostClosing],
        4: [Categories.Mortgage],
        5: [Categories.ClearanceSearch],
        9: [Categories.LandRegistration],
        12: [Categories.Hidden],
        13: [Categories.EnvelopeFax],
        14: [Categories.Subdocs],
        17: [Categories.WesternProtocol],
    },
    MB: {
        1: [Categories.Closing],
        2: [Categories.Initial],
        3: [Categories.PostClosing],
        4: [Categories.Mortgage],
        5: [Categories.SearchLettersRequests],
        9: [Categories.LandRegistration],
        12: [Categories.Hidden],
        13: [Categories.EnvelopeFax],
        14: [Categories.Subdocs],
        17: [Categories.WesternProtocol],
        18: [Categories.Rental],
        19: [Categories.BankForms],
    },
    NS: {
        1: [Categories.Closing],
        2: [Categories.Initial],
        3: [Categories.PostClosing],
        4: [Categories.Mortgage],
        5: [Categories.ClearanceSearch],
        9: [Categories.LandRegistration],
        12: [Categories.Hidden],
        13: [Categories.EnvelopeFax],
        14: [Categories.Subdocs],
    },
    SK: {
        1: [Categories.Closing],
        2: [Categories.Initial],
        3: [Categories.PostClosing],
        4: [Categories.Mortgage],
        5: [Categories.ClearanceSearch],
        9: [Categories.LandRegistration],
        12: [Categories.Hidden],
        13: [Categories.EnvelopeFax],
        14: [Categories.Subdocs],
        17: [Categories.WesternProtocol],
        18: [Categories.BankForms],
    },
};
